import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState(['health_insurance_types'])
    },

    mounted() {
        if(!this.health_insurance_types.length) {
            this.$store.dispatch('fetchHealthInsuranceTypes');
        }
    }

}
